import axios from 'axios';

// Talks to our own backend (serverless function in prod, setupProxy in dev),
// which proxies Spotify with the secret kept server-side.
const instance = axios.create({ baseURL: '/api' });

export default instance;
